export default __webpack_public_path__ + "static/Toyota_Tagline_Incorrect_Usage_6-032034ec4bc66cf9f7c49ef1fa499992.svg";